import { render, staticRenderFns } from "./YourEnquiriesStatic.vue?vue&type=template&id=6c476a4c&"
import script from "./YourEnquiriesStatic.vue?vue&type=script&lang=js&"
export * from "./YourEnquiriesStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports